import Joi from 'joi';

export const holidayValidationSchema = Joi.object({
    holidayDate: Joi.date()
        // .greater("now")
        .required()
        .messages({
            "date.base": "Holiday Date must be a valid date.",
            // "date.greater": "Holiday Date cannot be in the past.",
            "any.required": "Holiday Date is required.",
        }),
    holidayName: Joi.string()
        .trim() 
        .min(2)
        .max(100)
        .required()
        .messages({
            "string.empty": "Holiday Name is required.",
            "string.max": "Holiday Name must not exceed 100 characters.",
            "string.min": "Holiday name must be at least 2 characters.",
            "any.required": "Holiday Name is required.",
        }),
    holidayType: Joi.string().optional()
});
